import styles from './enter.module.scss';
import ArrImg from '@/assets/images/mobile/simulation/arrow.webp';

const EnterImg = ({ onclickArrow, color = 'blue' }) => {
    return (
        <div data-color={color} className={styles.arrowIconWrap} onClick={onclickArrow}>
            <img src={ArrImg} alt="" />
        </div>
    );
};
export default EnterImg;
